import {
  GET_SERVICES_SUCCESS,
  SERVICES_LOADING,
  SET_SERVICE,
  GET_SERVICE_DETAILS_SUCCESS,
  GET_SCROLL_SERVICES_SUCCESS,
} from "./Types";

export const GetServicesSuccess = (payload) => ({
  type: GET_SERVICES_SUCCESS,
  payload,
});

export const ServicesLoading = (payload) => ({
  type: SERVICES_LOADING,
  payload,
});

export const SetService = (payload) => ({
  type: SET_SERVICE,
  payload,
});

export const GetServiceDetailsSuccess = (payload) => ({
  type: GET_SERVICE_DETAILS_SUCCESS,
  payload,
});

export const GetScrollServicesSuccess = (payload) => ({
  type: GET_SCROLL_SERVICES_SUCCESS,
  payload,
});
